import { ServiceRequestExpense } from '../pages/admin/types';

export type ExpenseContext =
  | {
      type: 'service_request';
      serviceRequestId: string;
      homeId: string;
      visitId?: string | null;
    }
  | {
      type: 'visit';
      visitId: string;
      homeId: string;
    }
  | {
      type: 'home';
      homeId: string;
    };

type ExpenseContextLabelInput = Pick<
  ServiceRequestExpense,
  'service_request_id' | 'visit_id'
> & {
  service_request?: { title: string | null } | null;
  visit?: {
    visit_type?: string | null;
    scheduled_date?: string | null;
    internal_name?: string | null;
  } | null;
};

const formatVisitDate = (value: string | null | undefined): string => {
  if (!value) return 'Visit';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Visit';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getExpenseContextLabel = (expense: ExpenseContextLabelInput): string => {
  if (expense.service_request_id) {
    if (expense.service_request?.title) {
      return `Service Request: ${expense.service_request.title}`;
    }
    return 'Service Request expense';
  }

  if (expense.visit_id) {
    if (expense.visit?.internal_name) {
      return `Visit: ${expense.visit.internal_name}`;
    }
    if (expense.visit?.scheduled_date) {
      return `Visit: ${formatVisitDate(expense.visit.scheduled_date)}`;
    }
    if (expense.visit?.visit_type) {
      const visitType = expense.visit.visit_type.replace('_', ' ');
      return `Visit: ${visitType}`;
    }
    return 'Visit expense';
  }

  return 'Home expense';
};

export const buildExpenseContextFields = (context: ExpenseContext) => {
  if (context.type === 'service_request') {
    return {
      service_request_id: context.serviceRequestId,
      home_id: context.homeId,
      visit_id: context.visitId ?? null,
    };
  }

  if (context.type === 'visit') {
    return {
      service_request_id: null,
      home_id: context.homeId,
      visit_id: context.visitId,
    };
  }

  return {
    service_request_id: null,
    home_id: context.homeId,
    visit_id: null,
  };
};
